'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CamAdBlock = require('./CamAdBlock');

var _CamAdBlock2 = _interopRequireDefault(_CamAdBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CamAdBlock2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamAdBlock/index.js
// module id = 530
// module chunks = 11